import { useCallback, useMemo, useState } from 'react';

import { useIntl } from 'react-intl';

import useAuth from 'hooks/auth/use-auth';
import { useMParticleContext } from 'state/mParticle';
import { toast } from 'utils/toast';

export function useFavoriteOffers() {
  const { user } = useAuth();
  const { updateUserFavOffers, isAuthenticated } = useAuth();
  const { formatMessage } = useIntl();
  const { updateUserAttributes } = useMParticleContext();
  const [loading, setLoading] = useState<string[]>([]);

  const favoriteOffers = useMemo(() => {
    const userFavoriteOffers = user?.details?.favoriteOffers || [];
    return userFavoriteOffers.filter(offer => !!offer.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.details.favoriteOffers]);

  const isFavorite = useCallback(
    (offerId: string) => !!favoriteOffers.find(offer => offer.id === offerId),
    [favoriteOffers]
  );

  const toggleFavorite = async (offerId: string) => {
    if (!isAuthenticated()) {
      return;
    }

    let newFavorites = [];
    let message = '';

    setLoading([...loading, offerId]);

    if (favoriteOffers.find(offer => offer.id === offerId)) {
      newFavorites = favoriteOffers.filter(offer => offer.id !== offerId);
      message = formatMessage({ id: 'offerFavoriteRemoved' });
    } else {
      newFavorites = [...favoriteOffers, { id: offerId }];
      message = formatMessage({ id: 'offerFavoriteAdded' });
    }

    await updateUserFavOffers(newFavorites);

    updateUserAttributes({
      favoriteOffers: JSON.stringify(favoriteOffers.map(offer => offer.id)),
    });

    toast.success(message);

    setLoading(prevState => prevState.filter(offer => offer !== offerId));
  };

  const isOfferLoading = useCallback((offerId: string) => loading.includes(offerId), [loading]);

  return {
    favoriteOffers,
    toggleFavorite,
    isFavorite,
    isOfferLoading,
  };
}
